import React from "react";
import {
  ClaroButton,
  ClaroCardSimple,
  ClaroTextGeneral,
  ClaroTextDetail,
  ClaroImageBanner,
  ClaroModalCustom,
  ClaroLinkButton,
} from "@claropay/shared";

export default function ModalCard({
  isOpen,
  text,
  buttontext,
  textdetail,
  onclickModal,
  textLink,
  onClickImg,
  fontSizeDetail,
  srcImage,
  textSizeLinkButton,
  fontSizeTitle,
  heightImg,
  widthImg,
  imageMargin,
  fontFamilyTitle,
  colorTextModal1,
  marginTitle,
  widthButton,
  marginButton,
  paddingCard,
  fontFamilyButton,
  colorButton,
  backgroundColorButton,
  fontSizeButton,
  fontWeightTitle,
  fontFamilyTextdetail,
  colorTextdetail,
  marginTextDetail,
  textColorLinkButton,
  fontFamilyLinkButton,
  heightButton,
  paddingButton,
  variant,
}) {
  return (
    <Modal
      isOpen={isOpen}
      fontSizeTitle={fontSizeTitle}
      backgroundColor="rgba(0,0,0,0.1)"
      borderRadiusCard="8px"
      fontFamilyTitle={fontFamilyTitle ? fontFamilyTitle : "Amx-Regular"}
      heightImg={heightImg ? heightImg : "62px"}
      widthImg={widthImg ? widthImg : "62px"}
      backgroundColorButton={
        backgroundColorButton ? backgroundColorButton : "#202020"
      }
      height="100%"
      textDecorationLinkButton="underline"
      textAlignLinkButton="center"
      textTransformLinkButton="initial"
      widthLinkButton="100%"
      fontWeightLinkButton="bold"
      srcImage={srcImage}
      text={text}
      fontSizeDetail={fontSizeDetail}
      buttontext={buttontext}
      textdetail={textdetail}
      onclickModal={onclickModal}
      onClickImg={onClickImg}
      textLink={textLink}
      textSizeLinkButton={textSizeLinkButton}
      imageMargin={imageMargin}
      colorTextModal1={colorTextModal1}
      marginTitle={marginTitle}
      widthButton={widthButton}
      marginButton={marginButton}
      paddingCard={paddingCard}
      fontFamilyButton={fontFamilyButton}
      colorButton={colorButton}
      fontSizeButton={fontSizeButton}
      fontWeightTitle={fontWeightTitle}
      fontFamilyTextdetail={fontFamilyTextdetail}
      colorTextdetail={colorTextdetail}
      marginTextDetail={marginTextDetail}
      textColorLinkButton={textColorLinkButton}
      fontFamilyLinkButton={fontFamilyLinkButton}
      heightButton={heightButton}
      paddingButton={paddingButton}
      variant={variant}
    />
  );
}

function Modal(props) {
  switch (props.variant) {
    case "telcelAnon":
      return (
        <ClaroModalCustom
          isOpen={props.isOpen}
          backgroundColor={props.backgroundColor}
        >
          <ClaroCardSimple
            backgroundColor="#fff"
            height="auto"
            borderRadius={"16px"}
            padding={"16px 0px 0px 0px"}
            // minHeight='230px'
          >
            <section>
              <div style={{ marginBottom: "8px", paddingLeft: "16px" }}>
                <img
                  onClick={props.onClickImg}
                  width={32}
                  height={32}
                  src={props.srcImage}
                />
              </div>
              <div
                style={{
                  paddingLeft: "16px",
                }}
              >
                <ClaroTextGeneral
                  textmodal1
                  margin={
                    props.marginTitle ? props.marginTitle : "0px 0 16px 0"
                  }
                  width="100%"
                  Height="auto"
                  style={{ lineHeight: "24px", textAlign: "left" }}
                  padding="0px 0 0 0"
                  fontSize={props.fontSizeTitle}
                  fontFamily={props.fontFamilyTitle}
                  fontWeight={
                    props.fontWeightTitle ? props.fontWeightTitle : "700"
                  }
                  colorTextModal1={props.colorTextModal1}
                  dangerouslySetInnerHTML={{ __html: props.text }}
                ></ClaroTextGeneral>
              </div>
              <div
                style={{
                  paddingLeft: "16px",
                }}
              >
                <ClaroTextDetail
                  color={"#111"}
                  fontSize={props.fontSizeDetail}
                  fontFamily={props.fontFamilyTextdetail}
                  textAlign="left"
                  margin={
                    props.marginTextDetail
                      ? props.marginTextDetail
                      : "0px 0 30px 0"
                  }
                  padding="0"
                  height="auto"
                  dangerouslySetInnerHTML={{ __html: props.textdetail }}
                ></ClaroTextDetail>
              </div>
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "#F4F6FB",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                }}
              >
                <ClaroButton
                  border={props.borderButton ? props.borderButton : undefined}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  margin={
                    props.marginButton ? props.marginButton : "0 auto 16px auto"
                  }
                  style={{
                    boxShadow: "none",
                  }}
                  backgroundColor={"#FEC927"}
                  width={props.widthButton ? props.widthButton : "61.111vw"}
                  height={props.heightButton ? props.heightButton : "auto"}
                  textAlign="center!important"
                  lineHeight={
                    props.lineHeightButton ? props.lineHeightButton : "11.5vw"
                  }
                  borderRadius={
                    props.borderRadiusButton ? props.borderRadiusButton : "50px"
                  }
                  weight={
                    props.fontWeightButton ? props.fontWeightButton : "700"
                  }
                  activeBackground={"#FEC927"}
                  hoverBackground={"#FEC927"}
                  fontSize={props.fontSizeButton}
                  color={"#111"}
                  onClick={props.onclickModal}
                  btnTelcel={props.btnTelcel || false}
                  fontFamily={props.fontFamilyButton}
                  padding={
                    props.paddingButton ? props.paddingButton : undefined
                  }
                >
                  {props.buttontext}
                </ClaroButton>
              </div>
            </section>
          </ClaroCardSimple>
        </ClaroModalCustom>
      );
    default:
      return (
        <ClaroModalCustom
          isOpen={props.isOpen}
          backgroundColor={props.backgroundColor}
        >
          <ClaroCardSimple
            backgroundColor="#fff"
            height="auto"
            borderRadius={props.borderRadiusCard}
            padding={props.paddingCard}
            // minHeight='230px'
            
          >
            <section>
              <ClaroImageBanner
                imageModal
                margin={
                  props.imageMargin ? props.imageMargin : "-43px 0 30px 0"
                }
              >
                <img
                  onClick={props.onClickImg}
                  width={props.widthImg}
                  height={props.heightImg}
                  src={props.srcImage}
                />
              </ClaroImageBanner>
              <ClaroTextGeneral
                textmodal1
                margin={props.marginTitle ? props.marginTitle : "0px 0 16px 0"}
                width="100%"
                Height="auto"
                style={{ lineHeight: "28px" }}
                padding="0px 0 0 0"
                fontSize={props.fontSizeTitle}
                fontFamily={props.fontFamilyTitle}
                fontWeight={
                  props.fontWeightTitle ? props.fontWeightTitle : "700"
                }
                colorTextModal1={"#1E1E1E"}
                dangerouslySetInnerHTML={{ __html: props.text }}
              ></ClaroTextGeneral>
              <ClaroTextDetail
                color={
                  props.colorTextdetail ? props.colorTextdetail : "#838383"
                }
                fontSize={props.fontSizeDetail}
                fontFamily={props.fontFamilyTextdetail}
                textAlign="center"
                margin={
                  props.marginTextDetail
                    ? props.marginTextDetail
                    : "0px 0 32px 0"
                }
                padding="0"
                height="auto"
                dangerouslySetInnerHTML={{ __html: props.textdetail }}
              ></ClaroTextDetail>
              <ClaroButton
                border={props.borderButton ? props.borderButton : undefined}
                display="flex"
                justifyContent="center"
                alignItems="center"
                margin={
                  props.marginButton ? props.marginButton : "0 auto 16px auto"
                }
                backgroundColor={props.backgroundColorButton}
                width={props.widthButton ? props.widthButton : "61.111vw"}
                height={props.heightButton ? props.heightButton : "auto"}
                textAlign="center!important"
                lineHeight={
                  props.lineHeightButton ? props.lineHeightButton : "11.5vw"
                }
                borderRadius={
                  props.borderRadiusButton ? props.borderRadiusButton : "50px"
                }
                style={{
                  height: "40px",
                }}
                weight={props.fontWeightButton ? props.fontWeightButton : "700"}
                activeBackground={props.activeBackgroundButton}
                hoverBackground={props.hoverBackgroundButton}
                fontSize={props.fontSizeButton}
                color={props.colorButton}
                onClick={props.onclickModal}
                btnTelcel={props.btnTelcel || false}
                fontFamily={props.fontFamilyButton}
                padding={props.paddingButton ? props.paddingButton : undefined}
              >
                {props.buttontext}
              </ClaroButton>
              {props.textLink && props.textLink !== "" && (
                <ClaroLinkButton
                  textSize={props.textSizeLinkButton}
                  textColor={props.textColorLinkButton}
                  btnBackground={props.btnBackgroundLinkButton}
                  activeOpacity={props.activeOpacityLinkButton}
                  textAlign={props.textAlignLinkButton}
                  fontWeight={props.fontWeightLinkButton}
                  textDecoration={props.textDecorationLinkButton}
                  fontFamily={props.fontFamilyLinkButton}
                  width={props.widthLinkButton}
                  textTransform={props.textTransformLinkButton}
                  onClick={props.onclickModal}
                >
                  {props.textLink}
                </ClaroLinkButton>
              )}
            </section>
          </ClaroCardSimple>
        </ClaroModalCustom>
      );
  }
}